const BUTTON_POSITION = {
  BOTTOM_LEFT: "bottom-left",
  TOP_LEFT: "top-left",
  BOTTOM_RIGHT: "bottom-right",
  TOP_RIGHT: "top-right"
};
const CONFIRMATION_STRATEGY = {
  POPUP: "popup",
  MODAL: "modal",
  AUTO_APPROVE: "auto-approve",
  DEFAULT: "default"
};

export { BUTTON_POSITION, CONFIRMATION_STRATEGY };
